import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Pagination } from 'react-bootstrap';
import Select from './Select';


export default class ReactTablePagination extends PureComponent {
  constructor(props) {
    super(props);
    this.changePage = this.changePage.bind(this);
    this.changePageCount = this.changePageCount.bind(this);
  }

  changePageCount(evt) {
     this.props.onPageSizeChange(parseInt(evt.target.value, 10));
  }

  changePage(page) {
    const activePage = this.props.page + 1;
    if (page === activePage) {
      return;
    }

    this.props.onPageChange(page - 1);
  }

  render() {
    const activePage = this.props.page + 1;
    if (this.props.pages <= 1) {
        return <div />;
    }

    const maxButtonsNo = 10;
    const options = [...this.props.pageSizeOptions];
    if (this.props.pageSize && options.findIndex(v => v === this.props.pageSize) < 0) {
        options.push(this.props.pageSize)
        options.sort((a, b) => a - b);
    }

    return (
        <div>
        <Pagination activePage={activePage}
                    items={this.props.pages}
                    maxButtons={maxButtonsNo}
                    onSelect={(key) => {
                        this.changePage(key);
                    }}
                    first={this.props.pages > maxButtonsNo}
                    last={this.props.pages > maxButtonsNo}
                    prev={this.props.pages > maxButtonsNo}
                    next={this.props.pages > maxButtonsNo}
        />
        {this.props.showPageSizeOptions && (
            <div style={{ float: 'right', marginTop: '25px' }}>
            <Select field={{
                        name: 'PageCount',
                        value: this.props.pageSize,
                        onChange: this.changePageCount
                    }}
                    name="PageCount"
                    options={options.map((option) => { return { value: option, label: `${option} ${this.props.rowsText}` };} )}
                    onChange={this.changePageCount}
            />
            </div>)}
        </div>
    );
  }
}


ReactTablePagination.propTypes = {
    pages: PropTypes.number,
    page: PropTypes.number,
    onPageChange: PropTypes.func,
    previousText: PropTypes.string,
    nextText: PropTypes.string,
  };